import { type QueryClient } from '@tanstack/react-query';

type QueryKeyParams = {
  listingId: string;
  language: string;
  currency: string;
  measurementSystem: string;
  agentId?: string;
  secretAccessId?: string;
  password?: string;
  userId?: string | null;
};

export const LISTING_QUERY_KEY = 'listing';
export const SIMILAR_LISTINGS_QUERY_KEY = 'similar-listings';
export const PARENT_PROJECT_QUERY_KEY = 'parent-project';
export const PROJECT_UNITS_QUERY_KEY = 'project-units';
export const WHATSAPP_LEAD_QUERY_KEY = 'whatsapp-lead';

export const getListingQueryKey = ({
  listingId,
  language,
  currency,
  measurementSystem,
  secretAccessId = '',
  agentId = '',
  userId = '',
}: QueryKeyParams) => [LISTING_QUERY_KEY, listingId, language, currency, measurementSystem, secretAccessId, agentId, userId ?? ''];

export const removeListingQueriesWithUserId = (queryClient: QueryClient): void => {
  queryClient.removeQueries({
    predicate: (query) => {
      const rootKey = query.queryKey[0];
      const userId = query.queryKey.at(-1);
      return rootKey === LISTING_QUERY_KEY && typeof userId === 'string' && userId.length > 0;
    },
  });
};

export const getSimilarListingsQueryKey = ({ listingId, language, currency, measurementSystem, agentId = '' }: QueryKeyParams) => [
  SIMILAR_LISTINGS_QUERY_KEY,
  listingId,
  language,
  currency,
  measurementSystem,
  agentId,
];

export const getParentProjectQueryKey = ({ listingId, language, currency, measurementSystem }: QueryKeyParams) => [
  PARENT_PROJECT_QUERY_KEY,
  listingId,
  language,
  currency,
  measurementSystem,
];

export const INITIAL_PROJECT_UNITS_COUNT = 6;
export const MAX_PROJECT_UNITS_COUNT = 100;

export const getProjectUnitsQueryKey = ({
  listingId,
  language,
  currency,
  measurementSystem,
  pageSize = INITIAL_PROJECT_UNITS_COUNT,
}: QueryKeyParams & { pageSize?: number }) => [PROJECT_UNITS_QUERY_KEY, listingId, language, currency, measurementSystem, pageSize];
